<template>
    <page class="trigger-page" :busy="busy" :tabs="tabs">
        <div class="trigger-page-wrapper w-100 h-100">
            <validation-observer class="d-block trigger-form" ref="trigger_form" v-slot="{ meta }">
                <trigger-title @busy="handleBusy" />
                <trigger-events />
                <trigger-conditions v-if="!hasRecurringOrDateEvent" />
                <trigger-send-for-properties />
                <trigger-send-for-channels />
                <trigger-send-to />
                <trigger-actions ref="trigger_actions" />
                <b-row class="mt-2 justify-content-md-end no-gutters flex-md-row flex-column bottom-buttons-wrapper">
                    <b-button-group class="mr-md-2 mb-2 d-md-flex d-none">
                        <more-filters-dropdown
                            v-slot:default="{ handleDropdownShow, handleDropdownHide }"
                            class="more-filters"
                        >
                            <responsive-dropdown
                                :items="applyOncePerResOptions"
                                class="w-100 mb-2"
                                variant="primary"
                                @show="handleDropdownShow"
                                @hide="handleDropdownHide"
                                >{{ applyOncePerResLabel }}</responsive-dropdown
                            >
                            <form-square-switch
                                class="trigger-switch"
                                :labels="{
                                    checked: 'Last minute bookings',
                                    unchecked: 'Last minute bookings',
                                }"
                                v-model="applyToLastMinuteReservations"
                                sync="true"
                                @input="onChangeLastMinute"
                            />
                            <form-square-switch
                                class="trigger-switch"
                                :labels="{
                                    checked: 'Once per booking',
                                    unchecked: 'Once per booking',
                                }"
                                v-model="applyOncePerReservation"
                                sync="true"
                                @input="onChangeOncePerRes"
                            />
                        </more-filters-dropdown>
                    </b-button-group>
                    <div class="justify-content-between d-md-flex d-none">
                        <b-button
                            class="mr-md-2 mb-2 d-flex align-items-center outlined-button"
                            variant="outline-primary"
                            @click="showEmailModal"
                            :disabled="!meta.valid || !validTrigger || invalid"
                        >
                            <font-awesome-icon class="mr-1" :icon="['fas', 'paper-plane']" />
                            Send Test Email
                        </b-button>
                        <b-button
                            class="mr-md-2 mb-2 d-flex align-items-center outlined-button"
                            variant="outline-primary"
                            @click="showSmsModal"
                            :disabled="!meta.valid || !validTrigger || invalid"
                        >
                            <font-awesome-icon class="mr-1" :icon="['fas', 'comment-sms']" />
                            Send Test SMS
                        </b-button>
                        <b-button
                            class="mr-md-2 mb-2 d-flex align-items-center outlined-button"
                            variant="outline-primary"
                            @click="showPushModal"
                            :disabled="!meta.valid || !validTrigger || invalid"
                        >
                            <font-awesome-icon class="mr-1" :icon="['fas', 'bell']" />
                            Send Test Push Notification
                        </b-button>
                    </div>
                    <div class="d-flex justify-content-between">
                        <b-button
                            class="mr-md-2 mb-2 d-flex align-items-center"
                            variant="primary"
                            @click="save()"
                            :disabled="!meta.valid || !validTrigger || invalid"
                        >
                            <font-awesome-icon class="mr-1" :icon="['fas', 'check']" />
                            Save
                        </b-button>
                        <b-button
                            class="d-flex align-items-center mb-2 mr-2 mr-md-0"
                            variant="default"
                            @click="goToTriggerList"
                        >
                            <font-awesome-icon class="mr-1" :icon="['fas', 'xmark']" />
                            Cancel
                        </b-button>
                        <b-button-group class="mr-md-2 mb-2 d-md-none d-flex">
                            <more-filters-dropdown
                                v-slot:default="{ handleDropdownShow, handleDropdownHide }"
                                class="more-filters"
                            >
                                <responsive-dropdown
                                    :items="applyOncePerResOptions"
                                    class="w-100 mb-2"
                                    variant="primary"
                                    @show="handleDropdownShow"
                                    @hide="handleDropdownHide"
                                    >{{ applyOncePerResLabel }}</responsive-dropdown
                                >
                                <form-square-switch
                                    class="trigger-switch"
                                    :labels="{
                                        checked: 'Last minute bookings',
                                        unchecked: 'Last minute bookings',
                                    }"
                                    :value="applyToLastMinuteReservations"
                                    @input="onChangeLastMinute"
                                    :sync="true"
                                />
                                <form-square-switch
                                    class="trigger-switch"
                                    :labels="{
                                        checked: 'Once per booking',
                                        unchecked: 'Once per booking',
                                    }"
                                    :value="applyOncePerReservation"
                                    @input="onChangeOncePerRes"
                                    :sync="true"
                                />
                                <b-button
                                    class="mr-md-2 mb-2 d-flex align-items-center outlined-button"
                                    variant="outline-primary"
                                    @click="showEmailModal"
                                    :disabled="!meta.valid || !validTrigger || invalid"
                                >
                                    <font-awesome-icon class="mr-1" :icon="['fas', 'paper-plane']" />
                                    Send Test Email
                                </b-button>
                                <b-button
                                    class="mr-md-2 mb-2 d-flex align-items-center outlined-button"
                                    variant="outline-primary"
                                    @click="showSmsModal"
                                    :disabled="!meta.valid || !validTrigger || invalid"
                                >
                                    <font-awesome-icon class="mr-1" :icon="['fas', 'comment-sms']" />
                                    Send Test SMS
                                </b-button>
                                <b-button
                                    class="mr-md-2 mb-2 d-flex align-items-center outlined-button"
                                    variant="outline-primary"
                                    @click="showPushModal"
                                    :disabled="!meta.valid || !validTrigger || invalid"
                                >
                                    <font-awesome-icon class="mr-1" :icon="['fas', 'bell']" />
                                    Send Test Push Notification
                                </b-button>
                            </more-filters-dropdown>
                        </b-button-group>
                    </div>
                </b-row>
            </validation-observer>
            <trigger-test-modal
                :modalId="triggerTestEmailModal"
                @submit="sendTestEmail"
                actionType="EMAIL"
                :busy="busy"
            />
            <trigger-test-modal :modalId="triggerTestSmsModal" @submit="sendTestSms" actionType="SMS" :busy="busy" />
            <trigger-test-modal
                :modalId="triggerTestPushModal"
                @submit="sendTestPushNotification"
                actionType="PUSH"
                :busy="busy"
            />

            <modal title="Confirm" :id="unsavedDataModalId" ok-title="Confirm" @ok="goToTriggerList">
                If you switch to the “Triggers” tab, then all unsaved data will be lost.
            </modal>
        </div>
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import isEmpty from 'lodash/isEmpty';
    import isArray from 'lodash/isArray';
    import capitalize from 'lodash/capitalize';

    import api from '../../../api.jsx';
    import { formatResponseError } from '../../../utils/api';
    import { calculateSmsLength } from './helpers/helpers';
    import Page from '../../generic/page/page.vue';
    import modal from '../../generic/modal/modal.vue';
    import MoreFiltersDropdown from '../../generic/more-filters-dropdown/more-filters-dropdown.vue';
    import FormSquareSwitch from '../../generic/form-square-switch/form-square-switch.vue';
    import ResponsiveDropdown from '../../generic/responsive-dropdown/responsive-dropdown.vue';
    import { TRIGGER_ENDPOINT } from '../../../endpoints';

    import TriggerTitle from './components/trigger-title.vue';
    import TriggerEvents from './components/trigger-events.vue';
    import TriggerConditions from './components/trigger-conditions.vue';
    import TriggerSendForProperties from './components/trigger-send-for-properties.vue';
    import TriggerSendForChannels from './components/trigger-send-for-channels.vue';
    import TriggerSendTo from './components/trigger-send-to.vue';
    import TriggerActions from './components/trigger-actions.vue';
    import TriggerSettings from './components/trigger-settings.vue';
    import TriggerTestModal from './components/trigger-test-modal.vue';

    export default {
        name: 'TriggerEdit',
        components: {
            Page,
            TriggerTitle,
            TriggerEvents,
            TriggerConditions,
            TriggerSendForProperties,
            TriggerSendForChannels,
            TriggerSendTo,
            TriggerActions,
            TriggerSettings,
            TriggerTestModal,
            modal,
            MoreFiltersDropdown,
            FormSquareSwitch,
            ResponsiveDropdown,
        },
        data() {
            return {
                busy: false,
                triggerTestEmailModal: 'trigger-test-email-modal',
                triggerTestSmsModal: 'trigger-test-sms-modal',
                triggerTestPushModal: 'trigger-test-push-modal',
                unsavedDataModalId: 'unsaved-data-modal',
                invalid: false,
            };
        },
        mounted() {
            this.fetchAllData();
        },
        provide() {
            return {
                triggerId: this.triggerId,
                setInvalid: (val) => {
                    this.invalid = val;
                },
                setFormValues: (values) => {
                    this.$refs.trigger_form.setValues(values);
                },
            };
        },
        computed: {
            ...mapGetters('trigger', [
                'events',
                'conditions',
                'actions',
                'tagsLengthObj',
                'hasEvents',
                'hasActions',
                'hasRecurringOrDateEvent',
                'applyForEachProperty',
                'applyOncePerReservation',
                'applyToLastMinuteReservations',
                'sendTo',
                'editing',
                'teamMembers',
                'isLimited',
                'title',
                'properties',
                'channels',
            ]),
            applyOncePerResLabel() {
                return this.applyForEachProperty
                    ? 'All properties on booking invoice'
                    : 'First property on booking invoice';
            },
            applyOncePerResOptions() {
                return [
                    {
                        label: 'All properties on booking invoice',
                        click: () => this.onChangeForEachProperty(true),
                    },
                    {
                        label: 'First property on booking invoice',
                        click: () => this.onChangeForEachProperty(false),
                    },
                ];
            },
            triggerId() {
                return parseInt(this.$route.params.id);
            },
            validTrigger() {
                const isValidTeamMembers =
                    this.sendTo.length === 1 && this.sendTo.includes(2) ? this.teamMembers.length > 0 : true;
                return (
                    this.validSms && this.hasEvents && this.hasActions && this.sendTo.length > 0 && isValidTeamMembers
                );
            },
            hasSmsAction() {
                return this.actions.find((item) => item.type === 'SMS');
            },
            validSms() {
                if (!!this.hasSmsAction) {
                    return this.calculateSmsLength(this.hasSmsAction.sms, this.tagsLengthObj) <= 160;
                }
                return true;
            },
            tabs() {
                return [
                    {
                        title: 'Triggers',
                        active: false,
                        callback: () => {
                            if (this.editing) {
                                this.$bvModal.show(this.unsavedDataModalId);
                            } else {
                                this.goToTriggerList();
                            }
                        },
                    },
                    {
                        title: `${this.triggerId ? 'Edit' : 'Create'} Trigger`,
                        active: true,
                        route: `/app/trigger/${this.triggerId}/edit/`,
                    },
                ];
            },
        },
        methods: {
            isArray,
            calculateSmsLength,
            async fetchAllData() {
                this.busy = true;
                await this.fetchTriggerData();
                await Promise.all([
                    this.fetchProperties(),
                    this.fetchMetaData(),
                    this.fetchTeamMembers(),
                    this.fetchReportTemplates(),
                    this.fetchUploadedFiles(),
                    this.fetchEmailResponses(),
                    this.fetchTriggersOptions(),
                    this.fetchReportSettings(),
                ]);
                this.busy = false;
                this.$refs.trigger_form.setValues({
                    properties: this.properties,
                    channels_list: this.channels,
                    title: this.title,
                });
                if (!this.triggerId) {
                    this.$refs.trigger_form.validate();
                }
            },
            goToTriggerList() {
                this.$store.commit('trigger/setEditing', false);
                this.$router.push('/app/trigger/list');
            },
            onChangeForEachProperty(value) {
                this.$store.commit('trigger/setForEachProperty', value);
                this.$store.commit('trigger/setEditing', true);
            },
            onChangeOncePerRes(value) {
                this.$store.commit('trigger/setOncePerRes', value);
                this.$store.commit('trigger/setEditing', true);
            },
            onChangeLastMinute(value) {
                this.$store.commit('trigger/setLastMinute', value);
                this.$store.commit('trigger/setEditing', true);
            },
            async fetchTeamMembers() {
                try {
                    await this.$store.dispatch('trigger/fetchTeamMembers');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not fetch properties',
                    });
                }
            },
            async fetchProperties() {
                try {
                    await this.$store.dispatch('trigger/fetchProperties');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not fetch properties',
                    });
                }
            },
            async fetchReportTemplates() {
                try {
                    await this.$store.dispatch('trigger/fetchReportTemplates');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not report templates',
                    });
                }
            },
            async fetchReportSettings() {
                try {
                    await this.$store.dispatch('trigger/fetchReportSettings');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not fetch report settings',
                    });
                }
            },
            async fetchUploadedFiles() {
                try {
                    await this.$store.dispatch('trigger/fetchUploadedFiles');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not fetch uploaded files',
                    });
                }
            },
            async fetchEmailResponses() {
                try {
                    await this.$store.dispatch('trigger/fetchEmailResponses');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not fetch email responses',
                    });
                }
            },
            async fetchTriggerData() {
                try {
                    await this.$store.dispatch('trigger/fetchTriggerData', {
                        id: this.triggerId,
                    });
                } catch (e) {
                    console.log(e);
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not fetch trigger',
                    });
                }
            },
            async fetchMetaData() {
                try {
                    await this.$store.dispatch('trigger/fetchMetadata');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not triggers options',
                    });
                }
            },
            async fetchTriggersOptions() {
                try {
                    await this.$store.dispatch('trigger/fetchTriggersOptions');
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({
                        text: generic || 'Could not fetch metadata',
                    });
                }
            },
            generateErrors(fields) {
                Object.keys(fields).forEach((item) => {
                    let error = '';
                    const sectionName =
                        item.indexOf('conditions') > -1
                            ? 'Conditions:'
                            : item.indexOf('events') > -1
                            ? 'Events:'
                            : item.indexOf('channels') > -1
                            ? 'Channels:'
                            : '';

                    if (isArray(fields[item]) && fields[item].length > 0) {
                        error = fields[item][0];
                    } else {
                        error = fields[item];
                    }
                    this.errorToast({
                        text: `${capitalize(sectionName)} ${error}`,
                    });
                });
            },
            handleBusy(value) {
                this.busy = value;
            },
            showSmsModal() {
                if (!!this.hasSmsAction) {
                    this.$bvModal.show(this.triggerTestSmsModal);
                } else {
                    this.errorToast({ text: 'Please, add sms action.' });
                }
            },
            showEmailModal() {
                const hasEmailAction = this.actions.find((item) => item.type === 'EMAIL');
                if (hasEmailAction) {
                    this.$bvModal.show(this.triggerTestEmailModal);
                } else {
                    this.errorToast({ text: 'Please, add email action.' });
                }
            },
            showPushModal() {
                const hasPushNotificationAction = this.actions.find((item) => item.type === 'PUSH');
                if (hasPushNotificationAction) {
                    this.$bvModal.show(this.triggerTestPushModal);
                } else {
                    this.errorToast({ text: 'Please, add push notification action.' });
                }
            },
            async sendTestSms(values) {
                try {
                    const id = await this.save(true);
                    if (id) {
                        this.busy = true;
                        const { data } = await api.post(`${TRIGGER_ENDPOINT(id)}test-sms/`, values);

                        if (data.status != 0) {
                            this.errorToast({ text: data.message });
                        } else {
                            this.successToast({
                                text: 'Trigger successfully saved. Test sms sent.',
                            });
                        }
                        this.$bvModal.hide(this.triggerTestSmsModal);
                        this.busy = false;
                    }
                } catch (e) {
                    const { generic } = formatResponseError(e);

                    this.errorToast({
                        text: generic || 'Could not send test sms',
                    });
                } finally {
                    this.busy = false;
                }
            },
            async sendTestEmail(values) {
                try {
                    const id = await this.save(true);
                    this.busy = true;
                    const { data } = await api.post(`${TRIGGER_ENDPOINT(id)}test-email/`, values);

                    this.$bvModal.hide(this.triggerTestEmailModal);
                    this.busy = false;
                    if (data.some((item) => item.status !== 0)) {
                        const message = data.map((item) => item.message).join(', ');
                        this.errorToast({ text: message });
                    } else {
                        this.successToast({
                            text: 'Trigger successfully saved. Test emails sent.',
                        });
                    }
                } catch (e) {
                    this.busy = false;
                    const { generic } = formatResponseError(e);

                    this.errorToast({
                        text: generic || 'Could not send test email',
                    });
                }
            },
            async sendTestPushNotification(values) {
                try {
                    const id = await this.save(true);
                    if (id) {
                        this.busy = true;
                        const { data } = await api.post(`${TRIGGER_ENDPOINT(id)}test-push-notification/`, values);

                        if (data.status != 0) {
                            this.errorToast({ text: data.message });
                        } else {
                            this.successToast({
                                text: 'Trigger successfully saved. Test push notification sent.',
                            });
                        }
                        this.$bvModal.hide(this.triggerTestPushModal);
                        this.busy = false;
                    }
                } catch (e) {
                    const { generic } = formatResponseError(e);

                    this.errorToast({
                        text: generic || 'Could not send test push notification',
                    });
                } finally {
                    this.busy = false;
                }
            },
            async save(hideToast = false) {
                try {
                    this.busy = true;
                    const { id } = await this.$store.dispatch('trigger/save', {
                        id: this.triggerId,
                    });
                    if (!this.triggerId) {
                        this.$router.push(`/app/trigger/${id}/edit/`);
                    }
                    !hideToast && this.successToast({ text: 'Trigger succesfully saved.' });
                    this.rerenderTextEditor();
                    this.$store.commit('trigger/setEditing', false);
                    return id;
                } catch (e) {
                    const { generic, fields } = formatResponseError(e);
                    if (!isEmpty(fields)) {
                        this.$refs.trigger_form.setErrors(fields);
                        this.generateErrors(fields);
                    } else {
                        this.errorToast({
                            text: generic || 'Could not save trigger',
                        });
                    }
                } finally {
                    this.busy = false;
                }
            },
            rerenderTextEditor() {
                if (this.$refs.trigger_actions) {
                    this.$refs.trigger_actions.rerenderHtmlComponent();
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import './styles.scss';
</style>
